export const shouldResetGdadRoleSelectionOnGradeChange = (
  previousGrade: string | null,
  nextGrade: string,
): boolean => {
  if (previousGrade === null) return false;
  if (previousGrade === nextGrade) return false;

  // Initial hydration often transitions from "" -> saved grade. Do not clear saved role values.
  if (previousGrade.trim() === '') return false;

  return true;
};
